import React from "react";
var __jsx = React.createElement;
import { ALL_THEMES } from '@anm/constants/videoLandings';
import { injectGlobal } from '@anm/helpers/stateful/injectGlobal';
import { landingFontsMap } from '@anm/styles/fonts';
export var injectFonts = function injectFonts(_ref) {
  var currentTheme = _ref.currentTheme,
      isCustomization = _ref.isCustomization;
  var themeList = isCustomization ? ALL_THEMES : [currentTheme];
  themeList.forEach(function (t) {
    var fontUrls = landingFontsMap[t].url;
    fontUrls.forEach(function (f) {
      return injectGlobal({
        head: __jsx("link", {
          href: "".concat(f),
          key: f.toString(),
          rel: "preload",
          as: "style"
        })
      });
    });
  });
};